export default "__VITE_ASSET__BVjrgAyt__"